// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rights-settings .rights-settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
}
.rights-settings .rights-settings-grid .rights-settings-item {
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  padding: 1.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}
.rights-settings .rights-settings-grid .rights-settings-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
}
.rights-settings .rights-settings-grid .rights-settings-item:hover::before {
  left: 0;
}
.rights-settings .rights-settings-grid .rights-settings-item label {
  display: block;
  font-weight: 600;
  font-size: 1rem;
  color: #334155;
  margin-bottom: 1rem;
  text-transform: capitalize;
  letter-spacing: 0.5px;
  position: relative;
  z-index: 2;
}
.rights-settings .rights-settings-grid .rights-settings-item input[type=checkbox] {
  appearance: none;
  width: 60px;
  height: 32px;
  background: #cbd5e1;
  border-radius: 50px;
  position: relative;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 2;
}
.rights-settings .rights-settings-grid .rights-settings-item input[type=checkbox]::before {
  content: "";
  position: absolute;
  top: 4px;
  left: 4px;
  width: 24px;
  height: 24px;
  background: white;
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.rights-settings .rights-settings-grid .rights-settings-item input[type=checkbox]:checked {
  background: linear-gradient(135deg, #667eea 0%, var(--primary-color) 100%);
}
.rights-settings .rights-settings-grid .rights-settings-item input[type=checkbox]:checked::before {
  transform: translateX(28px);
}
.rights-settings .rights-settings-grid .rights-settings-item input[type=checkbox]:focus {
  outline: none;
}
.rights-settings .rights-settings-save-btn {
  width: 100%;
  max-width: 250px;
  margin: 0 auto;
  display: block;
  padding: 1rem;
  background: linear-gradient(135deg, #667eea 0%, var(--primary-color) 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  letter-spacing: 0.5px;
}
.rights-settings .rights-settings-save-btn:disabled {
  position: relative;
}
@keyframes spin {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
@media (max-width: 768px) {
  .rights-settings .rights-settings-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .rights-settings .rights-settings-grid .rights-settings-item {
    padding: 1.25rem;
  }
  .rights-settings .rights-settings-title {
    font-size: 1.5rem;
  }
}
@media (max-width: 480px) {
  .rights-settings .rights-settings-grid .rights-settings-item {
    padding: 1rem;
  }
  .rights-settings .rights-settings-grid .rights-settings-item label {
    font-size: 0.9rem;
  }
  .rights-settings .rights-settings-grid .rights-settings-item input[type=checkbox] {
    width: 50px;
    height: 28px;
  }
  .rights-settings .rights-settings-grid .rights-settings-item input[type=checkbox]::before {
    width: 20px;
    height: 20px;
    top: 4px;
    left: 4px;
  }
  .rights-settings .rights-settings-grid .rights-settings-item input[type=checkbox]:checked::before {
    transform: translateX(22px);
  }
  .rights-settings .rights-settings-save-btn {
    font-size: 1rem;
    padding: 0.875rem 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/GlobalSettingsPage/VisibilitySettings/VisibilitySettings.scss"],"names":[],"mappings":"AAYE;EACE,aAAA;EACA,2DAAA;EACA,WAAA;EACA,mBAAA;AAXJ;AAaI;EACE,6DAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;AAXN;AAaM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,gGAAA;EACA,kDAAA;EACA,UAAA;AAXR;AAmBQ;EACE,OAAA;AAjBV;AAqBM;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AAnBR;AAuBM;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iDAAA;EACA,UAAA;AArBR;AAuBQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iDAAA;AArBV;AAyBQ;EACE,0EAAA;AAvBV;AAyBU;EACE,2BAAA;AAvBZ;AAoCQ;EACE,aAAA;AAlCV;AAyCE;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;EACA,0EAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AAvCJ;AA2CE;EACE,kBAAA;AAzCJ;AAyDE;EACE;IAAK,6CAAA;EAtDP;EAuDE;IAAO,+CAAA;EApDT;AACF;AAsDE;EACE;IACE,0BAAA;IACA,SAAA;EApDJ;EAsDI;IACE,gBAAA;EApDN;EAwDE;IACE,iBAAA;EAtDJ;AACF;AAyDE;EAEI;IACE,aAAA;EAxDN;EA0DM;IACE,iBAAA;EAxDR;EA2DM;IACE,WAAA;IACA,YAAA;EAzDR;EA2DQ;IACE,WAAA;IACA,YAAA;IACA,QAAA;IACA,SAAA;EAzDV;EA4DQ;IACE,2BAAA;EA1DV;EAgEE;IACE,eAAA;IACA,wBAAA;EA9DJ;AACF","sourcesContent":["\n.rights-settings {\n\n  // .rights-settings-title {\n  //   font-size: 1.75rem;\n  //   font-weight: 600;\n  //   color: #1e293b;\n  //   margin-bottom: 2rem;\n  //   text-align: center;\n  //   position: relative;\n  // }\n\n  .rights-settings-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n    gap: 1.5rem;\n    margin-bottom: 3rem;\n\n    .rights-settings-item {\n      background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);\n      border: 2px solid #e2e8f0;\n      border-radius: 16px;\n      padding: 1.5rem;\n      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n      position: relative;\n      overflow: hidden;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: -100%;\n        width: 100%;\n        height: 100%;\n        background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);\n        transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n        z-index: 1;\n      }\n\n      &:hover {\n        // transform: translateY(-4px);\n        // box-shadow: 0 15px 30px rgba(102, 126, 234, 0.15);\n        // border-color: #667eea;\n\n        &::before {\n          left: 0;\n        }\n      }\n\n      label {\n        display: block;\n        font-weight: 600;\n        font-size: 1rem;\n        color: #334155;\n        margin-bottom: 1rem;\n        text-transform: capitalize;\n        letter-spacing: 0.5px;\n        position: relative;\n        z-index: 2;\n      }\n\n      // Custom toggle switch\n      input[type=\"checkbox\"] {\n        appearance: none;\n        width: 60px;\n        height: 32px;\n        background: #cbd5e1;\n        border-radius: 50px;\n        position: relative;\n        cursor: pointer;\n        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n        z-index: 2;\n\n        &::before {\n          content: '';\n          position: absolute;\n          top: 4px;\n          left: 4px;\n          width: 24px;\n          height: 24px;\n          background: white;\n          border-radius: 50%;\n          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n          // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n        }\n\n        &:checked {\n          background: linear-gradient(135deg, #667eea 0%, var(--primary-color) 100%);\n          \n          &::before {\n            transform: translateX(28px);\n            // box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n          }\n        }\n\n        // &:hover {\n        //   transform: scale(1.05);\n          \n        //   // &::before {\n        //   //   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n        //   // }\n        // }\n\n        &:focus {\n          outline: none;\n          // box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);\n        }\n      }\n    }\n  }\n\n  .rights-settings-save-btn {\n    width: 100%;\n    max-width: 250px;\n    margin: 0 auto;\n    display: block;\n    padding: 1rem;\n    background: linear-gradient(135deg, #667eea 0%, var(--primary-color) 100%);\n    color: white;\n    border: none;\n    border-radius: 12px;\n    font-size: 1.1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    position: relative;\n    overflow: hidden;\n    letter-spacing: 0.5px;\n    \n  }\n\n  .rights-settings-save-btn:disabled {\n    position: relative;\n    // &::after {\n    //   content: '';\n    //   position: absolute;\n    //   top: 50%;\n    //   left: 50%;\n    //   transform: translate(-50%, -50%);\n    //   width: 20px;\n    //   height: 20px;\n    //   border: 2px solid rgba(255, 255, 255, 0.3);\n    //   border-top: 2px solid white;\n    //   border-radius: 50%;\n    //   animation: spin 1s linear infinite;\n    // }\n  }\n\n  @keyframes spin {\n    0% { transform: translate(-50%, -50%) rotate(0deg); }\n    100% { transform: translate(-50%, -50%) rotate(360deg); }\n  }\n\n  @media (max-width: 768px) {\n    .rights-settings-grid {\n      grid-template-columns: 1fr;\n      gap: 1rem;\n\n      .rights-settings-item {\n        padding: 1.25rem;\n      }\n    }\n\n    .rights-settings-title {\n      font-size: 1.5rem;\n    }\n  }\n\n  @media (max-width: 480px) {\n    .rights-settings-grid {\n      .rights-settings-item {\n        padding: 1rem;\n        \n        label {\n          font-size: 0.9rem;\n        }\n\n        input[type=\"checkbox\"] {\n          width: 50px;\n          height: 28px;\n\n          &::before {\n            width: 20px;\n            height: 20px;\n            top: 4px;\n            left: 4px;\n          }\n\n          &:checked::before {\n            transform: translateX(22px);\n          }\n        }\n      }\n    }\n\n    .rights-settings-save-btn {\n      font-size: 1rem;\n      padding: 0.875rem 1.5rem;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
